import { useState } from 'react';
import { useMatrixParams } from '@/app/MatrixSwitch';
import { BusinessType } from '@/core/models/firm-settings.models';
import { TabGroup } from '@/kit/Tabs';
import { ChartTemplateGridView } from './ChartTemplateGrid';
import { useChartTemplateGrid } from './ChartTemplateGridBase';

/** Tab order matches the business type ids: 0 Limited, 1 Sole Trader, 2 Partnership, 3 LLP. */
function tabFromParam(raw: string | undefined): number {
  const type = Number(raw ?? null);
  return Number.isInteger(type) && type >= 0 && type <= 3 ? type : 0;
}

/**
 * Angular ChartofaccountsComponent: default chart of accounts per business type, `/home/settings/chart-accounts`
 * with the optional matrix param `type` (0..3) choosing the tab. As with Material's eagerly created tab content, all
 * four grids load when the page opens (the options request is shared); only the selected one is shown.
 */
export function Chartofaccounts() {
  const { type } = useMatrixParams();
  const [selectedIndex, setSelectedIndex] = useState(() => tabFromParam(type));

  // Angular subscribed to paramMap: a changed `type` param moves the tab.
  const [seenType, setSeenType] = useState(type);
  if (seenType !== type) {
    setSeenType(type);
    setSelectedIndex(tabFromParam(type));
  }

  const limited = useChartTemplateGrid(BusinessType.Limited);
  const soleTrader = useChartTemplateGrid(BusinessType.SoleTrader);
  const partnership = useChartTemplateGrid(BusinessType.Partnership);
  const llp = useChartTemplateGrid(BusinessType.Llp);

  return (
    <div>
      <div className="sidenav-details pt-5">
        <div className="sidenav-body">
          <TabGroup
            alignTabs="start"
            selectedIndex={selectedIndex}
            onSelectedIndexChange={setSelectedIndex}
            tabs={[
              {
                label: 'Limited',
                children: (
                  <div className="pt-10">
                    <ChartTemplateGridView grid={limited} />
                  </div>
                ),
              },
              {
                label: 'Sole Trader',
                children: (
                  <div className="pt-10">
                    <ChartTemplateGridView grid={soleTrader} />
                  </div>
                ),
              },
              {
                label: 'Partnership',
                children: (
                  <div className="pt-10">
                    <ChartTemplateGridView grid={partnership} />
                  </div>
                ),
              },
              {
                label: 'LLP',
                children: (
                  <div className="pt-10">
                    <ChartTemplateGridView grid={llp} />
                  </div>
                ),
              },
            ]}
          />
        </div>
      </div>
    </div>
  );
}
